<template>
  <div>
    <Row :gutter="20">
      <i-col :xs="12" :md="8" :lg="6" v-for="(infor, i) in inforCardData" :key="`infor-${i}`" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
          <count-to :end="infor.count" count-class="count-style"/>
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <Row style="margin-top: 10px;text-align: left">
       <i-col>
          <Card>
           <Form ref="searchForm" inline :model="searchForm">
            <FormItem label="项目名" prop="project" :label-width="58">
              <i-select v-model="searchForm.project" style="min-width: 218px" @on-change="handleProjectOnChange">
                <i-option v-for="item in projectOptions" :value="item" :key="item" :label="item"></i-option>
              </i-select>
            </FormItem>
            <FormItem label="显示条数" prop="size" :label-width="70">
              <InputNumber :max="1000" :min="1" v-model="searchForm.size" class="mob-w-100"></InputNumber>
              <a v-on:click="handleShowSize" style="line-height: 20px; padding-left: 10px"><Icon type="md-refresh" size="20"/></a>
            </FormItem>
            <FormItem label="只显示自己的提交记录" :label-width="150">
                <i-switch v-model="searchForm.switch1" @on-change="switchHandle" />
            </FormItem>
            <!-- <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="handleShow">查询提交记录</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem> -->
           </Form>
           <Table :columns="columns" :data="tableData" height="300"/>
           <div class="content" v-if="currentProject">
            <div class="main">
                <div>
                    <Row>
                         <Col span="24" :lg="12">
                            <Row class="title">
                                  <h4>基本信息</h4>
                            </Row>
                            <div class="info-property">
                              <dl>
                                  <dt>项目(中文名)</dt><dd>{{detail.name}}</dd>
                              </dl>
                              <dl>
                                    <dt>版本管理</dt><dd>{{ detail.code.version_control }}</dd>
                              </dl>
                                <dl>
                                    <dt>项目所在组</dt><dd>{{ detail.code.group }}</dd>
                                </dl>
                                <dl>
                                    <dt>代码地址</dt><dd>{{ detail.code.address }}</dd>
                                </dl>
                                <dl>
                                    <dt>开发语言</dt><dd>{{ detail.code.language }}</dd>
                                </dl>
                          </div>
                        </Col>
                        <Col span="24" :lg="12">
                            <Row class="title">
                                  <h4>项目关联人员</h4>
                            </Row>
                            <div class="info-property">
                              <dl>
                                  <dt>项目经理</dt><dd>{{detail.masters}}</dd>
                              </dl>
                              <dl>
                                  <dt>产品经理</dt><dd>{{detail.pms}}</dd>
                              </dl>
                              <dl>
                                  <dt>开发人员</dt><dd>{{detail.developers}}</dd>
                              </dl>
                              <dl>
                                  <dt>测试人员</dt><dd>{{detail.tests}}</dd>
                              </dl>
                              <dl>
                                  <dt>维护人员</dt><dd>{{detail.maintain}}</dd>
                              </dl>
                          </div>
                        </Col>
                    </Row>
                  </div>
               </div>
          </div>

         </Card>
         <Card>
           <Form ref="searchFormUser" inline :model="searchFormUser">
            <FormItem label="用户名" prop="project" :label-width="58">
              <i-select v-model="searchFormUser.id" style="min-width: 218px" @on-change="handleUserOnChange" :disabled="disabledSel">
                <i-option v-for="item in no_select_user" :value="item.key" :key="item.key" :label="item.label"></i-option>
              </i-select>
            </FormItem>
           </Form>
           <Table :columns="columnsProject" :data="tableDataProject" height="300"/>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import { getNodeUse, getPodList, getPodUse } from '@/api/cloud'
import { getProjectDashboard, getDeployTrend, getUserProjectsList, fetchProjectCommitsData, fetchProjectInfoData, getMemberSelList } from '@/api/project'
import DeployTrend from './DeployTrend.vue'
import moment from 'moment'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'DeployDashboard',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar,
    DeployTrend
  },
  data () {
    return {
      disabledSel: true,
      no_select_user: [],
      currentProject: '',
      detail: {},
      isAdmin: false,
      tableData: [],
      tableDataProject: [],
      columns: [
        { title: '提交ID', key: 'short_id', align: 'center', minWidth: 80 },
        {
          title: '提交时间',
          align: 'center',
          width: 160,
          key: 'committed_date',
          render: (h, params) => {
            if (params.row.committed_date) {
              return h('div', moment(params.row.committed_date).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        // { title: '提交人', key: 'committer_email', align: 'center', minWidth: 110 },
        { title: '提交人', key: 'committer_name', align: 'center', minWidth: 220 },
        { title: '提交描述', key: 'message', align: 'center', minWidth: 160 },
        { title: '标题', key: 'title', align: 'center', minWidth: 160 }
      ],
      columnsProject: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '项目名', key: 'name', align: 'center', minWidth: 100 },
        { title: '项目英文名', key: 'name_en', align: 'center', minWidth: 100 },
        { title: '项目负责人', key: 'masters', align: 'center', minWidth: 100 }
      ],
      searchForm: {
        project: null,
        size: 50,
        switch1: false
      },
      searchFormUser: {
        id: ''
      },
      projectOptions: [],
      inforCardData: [],
      nodeArray: [],
      podArray: [],
      countTotal: 0,
      countSuccess: 0,
      countBack: 0,
      countFail: 0,
      xData: [],
      yData: [],
      nodeSel: null,
      podSel: null,
      nodeCpu: null,
      cpuUse: 20,
      memUse: 310,
      podCpu: 0,
      podMem: 0,
      pieDataNodeCpu: [],
      pieDataNodeMem: [],
      pieDataPodCpu: {},
      pieDataPodMem: {}
    }
  },
  methods: {
    getProjectsList (params) {
      getMemberSelList(params).then(res => {
        this.tableDataProject = res.data
        this.tableDataProject.map((item, index) => {
          item.masters = item.masters ? item.masters.join(',') : ''
        })
      })
    },
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].name) {
              that.no_select_user.push({
                key: result[i].id,
                label: result[i].name
              })
            } else {
              that.no_select_user.push({
                key: result[i].id,
                label: result[i].username
              })
            }
          }
          if (this.$store.state.user.superuser) {
            this.searchFormUser.id = ''
            this.disabledSel = false
          } else {
            this.searchFormUser.id = this.$store.state.user.userId
            this.disabledSel = true
            this.handleUserOnChange(this.$store.state.user.userId)
          }
        }
      })
    },
    getProjectDetail (value) {
      fetchProjectInfoData(value).then(res => {
        this.detail = res.data
        this.detail.masters = this.detail.masters ? this.detail.masters.join(',') : ''
        this.detail.pms = this.detail.pms ? this.detail.pms.join(',') : ''
        this.detail.developers = this.detail.developers ? this.detail.developers.join(',') : ''
        this.detail.tests = this.detail.tests ? this.detail.tests.join(',') : ''
        this.detail.maintain = this.detail.maintain ? this.detail.maintain.join(',') : ''
      })
    },
    searchReset () {
      this.searchForm = {
        project: null,
        size: 50,
        switch1: false
      }
    },
    handleShowSize () {
      this.handleShow()
      if (this.searchForm.size !== 50) {
        this.getProjectDashboard(this.searchForm.size)
      }
    },
    handleShow () {
      if (this.searchForm.project) {
        let params = {
          is_mine: this.searchForm.switch1,
          size: this.searchForm.size,
          project: this.searchForm.project
        }
        this.fetchProjectCommitsData(params)
      } else {
        this.$Notice.error({title: '请先选择项目！'})
      }
    },
    switchHandle () {
      this.handleShow()
    },
    handleProjectOnChange (value) {
      this.currentProject = value
      this.getProjectDetail(this.searchForm.project)
      this.handleShow()
    },
    fetchProjectCommitsData (params) {
      fetchProjectCommitsData(params).then(res => {
        let commits = res.data.data
        this.tableData = commits
      }).catch(() => {
        this.tableData = []
      })
    },
    getProjectOptions () {
      let params = {
        code: 'git'
      }
      getUserProjectsList(params).then(res => {
        this.projectOptions = res.data
      })
    },
    getProjectDashboard (value) {
      this.inforCardData = []
      getProjectDashboard(value).then(res => {
        let totalProjectJson = { title: '应用总数', icon: 'ios-apps-outline', count: 803, color: '#2d8cf0' }
        let myProjectJson = { title: '我的项目', icon: 'ios-contact-outline', count: 803, color: '#2d8cf0' }
        let totalCommitJson = { title: '总共提交次数', icon: 'ios-checkmark-circle-outline', count: 232, color: '#19be6b' }
        let myCommitJson = { title: '你的提交次数', icon: 'md-arrow-back', count: 657, color: '#E46CBB' }
        totalProjectJson['count'] = res.data.project.project_count_all
        myProjectJson['count'] = res.data.project.project_count
        totalCommitJson['count'] = res.data.project.project_commit_all
        myCommitJson['count'] = res.data.project.project_commit
        this.inforCardData.push(totalProjectJson)
        this.inforCardData.push(myProjectJson)
        this.inforCardData.push(totalCommitJson)
        this.inforCardData.push(myCommitJson)
      })
    },
    getDeployTrend (value) {
      let params = {
        search: value
      }
      getDeployTrend(params).then(res => {
        console.log(res.data)
        this.xData = res.data.map(item => item[0])
        this.yData = res.data.map(item => item[1])
        console.log(this.xData)
      })
    },
    getPodList () {
      getPodList().then(res => {
        this.podArray = res.data
      })
    },
    handleNodeOnChange (value) {
      this.getNodeUse(value)
      this.getPodList(value)
    },
    handlePodOnChange (value) {
      this.getPodUse(value)
    },
    getNodeUse (value) {
      let that = this
      that.pieDataNodeCpu = []
      that.pieDataNodeMem = []
      // 读取选择节点的 使用情况
      getNodeUse(value).then(res => {
        let valueCpu1 = { value: res.data.cpu_usage, name: '已使用(m)' }
        let valueCpu2 = { value: res.data.free_cpu, name: '空闲(m)' }
        let valueMem1 = { value: res.data.mem_usage, name: '已使用(Mi)' }
        let valueMem2 = { value: res.data.free_mem, name: '空闲(Mi)' }
        that.pieDataNodeCpu.push(valueCpu1)
        that.pieDataNodeCpu.push(valueCpu2)
        that.pieDataNodeMem.push(valueMem1)
        that.pieDataNodeMem.push(valueMem2)
      })
    },
    // 得到当前选择的Node的相关pod监控情况
    getPodUse (value) {
      let that = this
      that.pieDataPodCpu = {}
      that.pieDataPodMem = {}
      // 读取选择节点的 使用情况
      getPodUse(value).then(res => {
        let key1 = res.data.time
        let cpuData = {}
        let menData = {}
        cpuData[key1] = res.data.cpu_usage
        menData[key1] = res.data.mem_usage
        console.log(key1)
        that.pieDataPodCpu = cpuData
        that.pieDataPodMem = menData
      })
    },
    initData () {
      if (this.$store.state.user.superuser) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    },
    handleUserOnChange (value) {
      let params = {
        id: value
      }
      this.getProjectsList(params)
    }
  },
  mounted () {
    this.getProjectDashboard(50)
    this.getProjectOptions()
    this.getNoSelectUser()
    this.initData()
  }
}
</script>

<style lang="less">
  @import '../../flow/base.less';
</style>

<style lang="less" scoped>
.count-style{
  font-size: 50px;
}
@baseColor: ~"#dc9387";
.countto-page-row{
  height: 200px;
}
.count-to-con{
  display: block;
  width: 100%;
  text-align: center;
}
.count-text{
  font-size: 50px;
  color: @baseColor;
}
.slot-text{
  font-size: 22px;
}
.unit-class{
  font-size: 30px;
  color: @baseColor;
}
</style>
